export default __webpack_public_path__ + "static/media/icon-user.346ff90d.svg";